// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__CgYut","buttons":"PendingPaymentAlert_buttons__1VB0Q"};